/* eslint-disable react/prop-types */
const ErrorMessageComponent = ({ message }) => {
  return message && <p className="text-xs text-red-700 mt-2">{message}</p>;
};

export default ErrorMessageComponent;
